export function history(state) {
   return state.history;
}

export function previous(state) {
   return state.history.length > 0 ? state.history[0] : null;
}

export function hasPrevious(state) {
   return state.history.length > 0;
}
